import type { InfoEvent, AdInfoSlotPayload } from "common-types";
import type { AdNodeManager } from "../../../core/AdNodeManager";
import type { SlotName } from "../../../config/platforms/types";
import { buildSlotInfo } from "../helpers/buildSlotInfo";
import { pushTrack } from "utils";

export function sendInfoTrack(
  track: InfoEvent,
  slot: googletag.Slot,
  nodeManager: AdNodeManager,
  size?: string,
) {
  const slotIdName = slot.getSlotElementId() as SlotName;
  const node = nodeManager.getAdNodeByName(slotIdName);
  if (!node) {
    return;
  }

  const trackPayload: AdInfoSlotPayload = {
    slotName: slotIdName,
    slotInfo: buildSlotInfo(slot, node, size),
    rv: node.getRenderCount(),
  };

  pushTrack(track, trackPayload);
}
